import React from 'react'

const AdCloseIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="30"
      height="33"
      viewBox="0 0 39 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.0605469"
        width="38.9402"
        height="32.5183"
        rx="5"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M21.3371 16.2588L28.7852 23.7069L26.9783 25.5137L19.5303 18.0656L12.0822 25.5137L10.2754 23.7069L17.7235 16.2588L10.2754 8.81072L12.0822 7.00391L19.5303 14.452L26.9783 7.00391L28.7852 8.81072L21.3371 16.2588Z"
        fill="white"
      />
    </svg>
  )
}

export default AdCloseIcon
